export const getFileUrl = (fileSlug) => {
    return `https://api.be-native.life/api/file/${fileSlug}`
}